export default {
  setAccount: {
    accountList: {
      createMedium: '创建中',
      overMedium: '已创建',
      primaryLedger: '主要分类账',
      subsidiaryLedger: '辅助分类账',
      ledgerCode: '分类账代码',
      ledgerName: '分类账名称',
      currency: '币种',
      subjectList: '科目表',
      writeLedgerCode: '请输入分类账代码',
      legalEntityName: '法人主体',
      writeLegalEntityName: '请输法人主体',
      ledgerType: '类型',
      extendLedgerCode: '关联的主要分类账',
      accountCalendarCode: '日历类型',
      currencyName: '本位币',
      accountChartCode: '会计科目',
      ledgerStatus: '状态',
      creatLedger: '创建分类账',
      creatAccount: '创建账套',
      viewAccount: '分类账选项',
      accountChartError: '该法人主体已被分配账套!',
      ledgerCodeValidRules: '请输入分类账代码',
      ledgerNameValidRules: '请输入分类账名称',
      accountChartCodeValidRules: '请选择会计科目表',
      accountCalendarCodeValidRules: '请选择会计日历',
      currencyCodeValidRules: '请选择本位币',
      ledgerNameFlagHad: '分类账名称已存在',
      choseFlagHad: '存在已分配账套的法人主体',
      ledgerCodeFlagHad: '分类账代码已存在',
    },
    creatAccount: {
      goBack: '取消',
      toPrev: '上一步',
      toNext: '下一步',
      pageNext: '步骤',
      pageNumber: '3',
      legalEntity: '存在重复的法人主体',
      action: '注意',
      actionTitle:
        '请仔细检查您的会计科目设置，然后保存，一旦保存您将无法更改主要分类账信息，若要更改请返回以前步骤。',
      saveCancelled: '已取消保存',
      selectAccount: '查询账套',
    },
    viewAccount: {
      corporateInformation: '法人信息',
      newLegalEntity: '新增法人主体',
      detelLegalEntity: '删除法人主体',
      legalEntityCode: '代码',
      legalEntityRegionCode: '国家（地区）',
      registrationCode: '统一社会信用代码',
      legalAddress: '注册地址',
      defaultExchangeType: '默认汇率类型',
      writeDefaultExchangeType: '请选择默认汇率类型',
      accountCalendarCode: '会计日历',
      initOpenPeriod: '初始打开期间',
      writeInitOpenPeriod: '请选择初始打开期间',
      create: '修改',
      overcreate: '完成',
      writeLedgerName: '请输入分类账名称',
      changeLegalEntityCode: '请选择法人主体',
      canNotDeletLedger: '已保存的法人主体不可删除',
    },
    distribution: {
      nextPage: '2',
      distributionLegalEntity: '分配法人主体',
      essentialInformation: '基本信息',
      confirmledgerInformation: '确认分类账信息',
    },
    setInformation: {
      nextPage: '1',
      defineLedgerInformation: '定义分类账信息',
      ledgerName: '名称',
      accountChartCode: '会计科目表',
      accountCalendarCode: '会计日历',
      currencyCode: '本位币',
      onlyAddOnePice: '最多添加一条法人信息',
    },
    sureInformation: {
      nextPage: '3',
      writeledgerName: '请输入名称',
      accountChartCode: '请选择会计科目表',
      accountCalendarCode: '请选择会计日历',
      currencyCode: '请选择本位币',
      index: '序号',
    },
  },
};
